<template>
    <div id="recoveryProfit">
        <el-col style="width:100%">
            <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" :label-position="labelPosition">
                <el-form-item class="fr">
                    <el-col style="width:520px;text-align:right">
                        <el-button  size="medium" type="success" @click="createClass">新建利润率</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
        <el-card class="box-card">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="id"
                    label="id">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="begin"
                    label="开始价格">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="end"
                    label="结束价格">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="price"
                    label="利润率（%）">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作" >
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click.stop="handleDel(scope.$index, scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[30, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
        <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="500px" @close="emptyDialog('materForm')">
            <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition">
                <el-form-item label="开始价格：" :required="dialogMenuStatus == 'create'">
                    <el-input type="number" placeholder="请输入开始价格" v-model.trim="materForm.begin"></el-input>
                </el-form-item>
                <el-form-item label="结束价格:" :required="dialogMenuStatus == 'create'">
                    <el-input  type="number" placeholder="请输入结束价格" v-model.trim="materForm.end"></el-input>
                </el-form-item>
                <el-form-item label="利润率(%):" :required="dialogMenuStatus == 'create'">
                    <el-input  type="number" v-model.trim="materForm.price" placeholder="请输入利润率"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
                <el-button v-else type="success" @click="saveEventFormSubmitBtn('materForm')">保存</el-button>
                <el-button @click="emptyDialog('materForm')">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getFareIncreaseList, recoveryAdd, recoveryUpdate, recoveryDelete
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'recoveryProfit',
        components: {},
        data () {
            return {
                canSet:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改利润率",
                    create: "新增利润率"
                },
                dislogCreate:false,
                labelPosition:'left',
                materForm:{
                    begin: '',
                    end: '',
                    price: '',
                },
                searchForm:{
                    classificationName: '',
                    classificationNumber: '',
                },
                returnData: [],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 30,
                },
                basicsAuth:{
                    recoveryAdd:false,
                    recoveryUpdate:false
                }
            }
        },
        mounted () {
            this.getMaterialClass()
            // this.basicsAuth.insertMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/insertMaterialClassification');
            // this.basicsAuth.updateMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/updateMaterialClassification');
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getMaterialClass()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getMaterialClass()
            },
            //清空form
            emptyDialog(formName) {
                this.dislogCreate = false
                this.$refs[formName].resetFields();
            },
            ///查询物料分类
            getMaterialClass(){
                let para={
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                getFareIncreaseList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建分类
            createClass() {
                this.materForm = {
                    begin: '',
                    end: '',
                    price: '',
                },
                this.dialogMenuStatus = "create";
                this.dislogCreate = true;
                this.canSet = false
            },
            //确定新增利润率
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                          begin: this.materForm.begin,
                          end: this.materForm.end,
                          price: this.materForm.price,
                        }
                        recoveryAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialClass();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑分类
            exitBtn(index,item) {
                this.canSet = false
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.materForm = Object.assign({}, item);
            },

            //删除
            handleDel: function(index, row) {
              this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning"
              })
                .then(() => {
                  //this.listLoading = true;
                  //NProgress.start();
                  let para = { id: row.id };

                  recoveryDelete(para).then(res => {
                    //this.listLoading = false;
                    //NProgress.done();
                    this.$message({
                      message: "删除成功",
                      type: "success"
                    });
                    /*刷新*/
                   this.getMaterialClass();
                  });
                })
                .catch(() => {});
            },
            //确定保存分类
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        /*获取当前input上输入的文字*/
                        let para={
                            id: this.materForm.id,
                            begin: this.materForm.begin,
                            end: this.materForm.end,
                            price: this.materForm.price,
                        }
                        recoveryUpdate(para).then(res => {
                            if (res.status===200) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialClass();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //清空刷新
            refresh() {
                this.getMaterialClass()
            },
            //确认检索
            SubmitSearch() {
                this.getMaterialClass()
            },
            clearFrom(){
                this.searchForm = {}
            }
        },
        computed: {},
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// recoveryProfit.vue?6784708a